// Open mega menu (mobile)

jQuery(".m-menu__mobile a[href$='/product-search/']").bind("click",function(e){
    jQuery(this).parent().toggleClass("js-m-menu__mobile-mega--isactive");
    e.preventDefault();
});

// Open mega menu (primary)

jQuery(".m-menu__primary a[href$='/product-search/']").bind("focus mouseover",function(){
    jQuery(this).parent().addClass("js-m-menu__primary--isactive");
    jQuery(".m-header__mega").addClass("js-m-header__mega--isactive");
});

// Close mega menu (primary) – allows user to tab around within header, without dismissing mega menu

jQuery(".m-header").bind("clickoutside focusoutside",function(e){
    jQuery(".js-m-menu__primary--isactive").removeClass("js-m-menu__primary--isactive");
    jQuery(".js-m-header__mega--isactive").removeClass("js-m-header__mega--isactive");
});

// Open menu (mobile)

jQuery(".m-header__nav-toggle button").bind("click",function(){
    jQuery(".m-menu__mobile").addClass("js-m-menu__mobile--isactive");
    jQuery(".m-menu__mobile-toggle").focus();
});

// Close menu (mobile)

jQuery(".m-menu__mobile-toggle").bind("click",function(){
    jQuery(".m-menu__mobile").removeClass("js-m-menu__mobile--isactive");
    jQuery(".m-header__nav-toggle button").focus();
});